import React from "react";
import type { SrFaceMatch } from "./sr-face-check-types";
import { getPhotoLink } from "./sr-face-check-types";

type Props = {
    match: SrFaceMatch;
    selected: boolean;
    disabled?: boolean;
    onSelect: (voterid: string) => void;
};

const SrFaceMatchCard = ({ match, selected, disabled, onSelect }: Props) => {
    const voterid = String(match.voterid || "");
    const voter = match.voter || {};
    const name = String(
        (voter as any)?.profile?.name_eng ||
            (voter as any)?.name_eng ||
            (voter as any)?.name ||
            "Matched voter"
    );
    const latestSrc = getPhotoLink(match.latest_photo) || getPhotoLink(match.photos?.[0]);
    const requestCount = Array.isArray(match.service_requests) ? match.service_requests.length : 0;
    const scorePct = typeof match.score === "number" ? Math.round(match.score * 100) : null;

    return (
        <button
            type="button"
            disabled={disabled || !voterid}
            onClick={() => onSelect(voterid)}
            className={`w-full rounded-xl border p-3 text-left transition ${
                selected
                    ? "border-blue-500 bg-blue-50 ring-2 ring-blue-200"
                    : "border-gray-200 bg-white hover:border-gray-300"
            } disabled:opacity-50`}
        >
            <div className="flex gap-3">
                <div className="h-14 w-14 shrink-0 overflow-hidden rounded-lg bg-gray-100">
                    {latestSrc ? (
                        <img src={latestSrc} alt={name} className="h-full w-full object-cover" />
                    ) : (
                        <div className="flex h-full items-center justify-center text-xs text-gray-400">
                            No photo
                        </div>
                    )}
                </div>
                <div className="min-w-0 flex-1">
                    <p className="truncate text-sm font-semibold text-gray-900">{name}</p>
                    <p className="mt-0.5 text-xs text-gray-500">{voterid || "—"}</p>
                    <div className="mt-1 flex flex-wrap gap-2 text-xs">
                        {scorePct != null && (
                            <span className="rounded bg-amber-50 px-1.5 py-0.5 text-amber-800">
                                {scorePct}% match
                            </span>
                        )}
                        {match.same_voterid && (
                            <span className="rounded bg-green-50 px-1.5 py-0.5 text-green-700">
                                Same voter ID
                            </span>
                        )}
                        <span className="rounded bg-slate-100 px-1.5 py-0.5 text-slate-600">
                            {requestCount} request{requestCount === 1 ? "" : "s"}
                        </span>
                    </div>
                </div>
            </div>
        </button>
    );
};

export default SrFaceMatchCard;
